import type { Components, Theme } from '@mui/material';

export const dividerConfig: Components<Omit<Theme, 'components'>> = {
  MuiDivider: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderColor: theme.palette.semantic.border.divider,
      }),
    },
  },
};
